import React from 'react';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';
import { P2GLink } from '@parcel2go/core-ui';

interface IClipboardProps {
  value: string | number;
  onCopied?: () => void;
  children?: React.ReactNode;
}

const useStyles = makeStyles()((theme) => ({
  icon: {
    opacity: 0.7,
    transition: 'opacity .4s ease',
    '&:hover': {
      opacity: 1
    },
    '& svg': {
      '& path': {
        transition: 'fill .4s ease'
      }
    },
    '&.active': {
      '& svg': {
        '& path': {
          fill: theme.palette.success.main
        }
      }
    }
  }
}));

export const Clipboard: React.FC<IClipboardProps> = ({ value, onCopied, children }: IClipboardProps) => {
  const { classes } = useStyles();

  async function copyTextToClipboard(e: React.MouseEvent<HTMLElement>) {
    e.preventDefault();
    e.stopPropagation();

    try {
      await navigator.clipboard.writeText(value.toString());
    } catch (error: unknown) {
      if (typeof error === 'object' && error !== null && 'message' in error) {
        console.error(error.message);
      }
    }

    if (onCopied) {
      onCopied();
    }
  }

  if (!navigator.clipboard) {
    return null;
  }

  return (
    <P2GLink onClick={copyTextToClipboard} classNames={clsx('p2g-clipboard', classes.icon)}>
      {children}
    </P2GLink>
  );
};
